import RentersInsuranceLayout from 'src/layouts/RentersInsuranceLayout';
import { ComplianceTerms } from './ComplianceTerms';
import { ComplianceDataValidatorGuard } from './guards/compliance-data-validator.guard';
import { useNavigate } from 'react-router-dom';
import { useLocationSearch } from '../../helpers/hooks/useLocationSearch';
import { ROUTES } from '../../constants/routes';

export const ComplianceTermsContainer = () => {
  const navigate = useNavigate()
  const getUrlWithQueryParams = useLocationSearch();

  const handleBackButtonClick = () => {
    navigate(getUrlWithQueryParams(ROUTES.COMPLIANCE_PATH));
  }

  return (
    <ComplianceDataValidatorGuard>
      <RentersInsuranceLayout
        headerProps={{
          v2: true,
          backButtonAction: handleBackButtonClick
        }}
        footerProps={{ withMarginTop: false, complianceFlowFooter: true }}
        progressBarProps={{ progress: '50%' }}
      >
        <ComplianceTerms />
      </RentersInsuranceLayout>
    </ComplianceDataValidatorGuard>
  );
};
